import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'

import {
  CustomizeExpandButton,
  ListButtonAccordion,
  ListButtonAccordionContainer,
} from '@opentrons/components'

import { getOnlyLatestDefs } from '../../../labware-defs'
import { getCustomLabwareDefsByURI } from '../../../labware-defs/selectors'
import { selectLid } from '../../../labware-ingred/actions'
import { selectors } from '../../../labware-ingred/selectors'
import { getIsNestedDefinitionALid } from './utils'

import type { ChangeEvent } from 'react'
import type { ThunkDispatch } from '../../../types'

interface SelectLidOnLabwareProps {
  lidLoadNames: string[]
  parentLabwareURI: string
  isAdapter: boolean
  category: string
  loadName: string
  lidURIs: string[]
}
export function SelectLidOnLabware(
  props: SelectLidOnLabwareProps
): JSX.Element | null {
  const {
    lidLoadNames,
    parentLabwareURI,
    isAdapter,
    category,
    loadName,
    lidURIs,
  } = props
  const { t } = useTranslation('starting_deck_state')
  const customLabwareDefs = useSelector(getCustomLabwareDefsByURI)
  const dispatch = useDispatch<ThunkDispatch<any>>()
  const defs = getOnlyLatestDefs()
  const zoomedInSlotInfo = useSelector(selectors.getZoomedInSlotInfo)
  const { selectedTopLabware, selectedLidLabware } = zoomedInSlotInfo
  const handleSelectLabware = (
    defUri: string,
    e: ChangeEvent<HTMLInputElement>
  ): void => {
    e.stopPropagation()
    dispatch(
      selectLid({
        labwareDefURI: defUri,
      })
    )
  }

  return !isAdapter &&
    parentLabwareURI === selectedTopLabware.labwareDefURI &&
    lidURIs.length > 1 ? (
    <ListButtonAccordionContainer id={`accordionContainer_${loadName}`}>
      <ListButtonAccordion
        key={`${category}_${loadName}_accordion`}
        isNested
        mainHeadline={t('labware_compatible_lids')}
        isExpanded={parentLabwareURI === selectedTopLabware.labwareDefURI}
      >
        {lidURIs.map(defUri => {
          const def = defs[defUri] ?? customLabwareDefs[defUri]

          return (
            <CustomizeExpandButton
              isNestedDefALid={getIsNestedDefinitionALid(def)}
              allowInputField={lidLoadNames.includes(def.parameters.loadName)}
              key={`${category}_${loadName}_${defUri}`}
              id={`${category}_${loadName}_${defUri}`}
              buttonText={def?.metadata.displayName ?? ''}
              buttonValue={defUri}
              onChange={e => {
                handleSelectLabware(defUri, e)
              }}
              isSelected={defUri === selectedLidLabware}
            />
          )
        })}
      </ListButtonAccordion>
    </ListButtonAccordionContainer>
  ) : null
}
